import { AnimatePresence, motion } from "motion/react";
import { getCatalog } from "../i18n";
import { softSpring } from "../lib/motion";
import { usePresentedSnapshot } from "../presentation/hooks";
import { focusedNodeId, useNexusStore } from "../store/nexusStore";

const maxRevisionSegments = 2;

function compactRevision(revision: string) {
  return revision.split(" / ").slice(0, maxRevisionSegments).join(" / ");
}

function SwappingTelemetry({ value }: { value: string }) {
  return (
    <span className="telemetry-swap">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={value}
          initial={{ opacity: 0, y: -3, filter: "blur(2px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          exit={{ opacity: 0, y: 3, filter: "blur(2px)" }}
          transition={softSpring}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}

export function CornerTelemetry() {
  const snapshot = usePresentedSnapshot();
  const focus = useNexusStore((state) => state.focus);
  const locale = useNexusStore((state) => state.locale);
  const dataSource = useNexusStore((state) => state.dataSource);
  const ui = getCatalog(locale).ui;
  const selectedId = focusedNodeId(focus);
  const selected = snapshot?.nodes.find((node) => node.id === selectedId);
  const revision = compactRevision(snapshot?.revision ?? "INITIALIZING");

  return (
    <div aria-hidden="true">
      <div className="telemetry telemetry--left">
        <motion.div
          className="telemetry__content"
          initial={{ opacity: 0, x: -5 }}
          animate={{ opacity: 1, x: 0 }}
          transition={softSpring}
        >
          <span>{ui.map} / KX.04</span>
          <SwappingTelemetry value={`${ui.frame} / ${selected ? ui.local : ui.cosmos}`} />
          <SwappingTelemetry value={`${ui.focusLabel} / ${selected?.label ?? ui.allSystems}`} />
        </motion.div>
      </div>
      <div className="telemetry telemetry--right">
        <motion.div
          className="telemetry__content"
          initial={{ opacity: 0, x: 5 }}
          animate={{ opacity: 1, x: 0 }}
          transition={softSpring}
        >
          <SwappingTelemetry value={revision} />
          <span>{ui.edge} / CF-WORKERS</span>
          <SwappingTelemetry value={`${ui.data} / ${dataSource === "live" ? ui.live : ui.fallback}`} />
        </motion.div>
      </div>
    </div>
  );
}
